import { useErrorHandlingLazyQuery } from '@backoffice-frontend/data-fetching'
import { isProduction } from '@backoffice-frontend/environment'
import { useUserHasAccess } from '@backoffice-frontend/restricted'
import { useGlobalRegion } from '@backoffice-frontend/service-area-picker'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { useEffect } from 'react'
import { useAlertsBadgeCountLazyQuery } from './alertsBadgeCount.hook'

const tenSeconds = 10 * 1000
const oneMinute = 60 * 1000
const OPEN_ALERTS_POLL_INTERVAL = isProduction() ? tenSeconds : oneMinute

export const useAlertsBadgeCount = () => {
  const [region] = useGlobalRegion()

  const userCanSeeAlerts = useUserHasAccess({
    requiredRights: [BoumRight.FLEET_CONTROL_TASK_R],
  })

  const [fetchOpenAlerts, { data: queryResult }] = useErrorHandlingLazyQuery(
    useAlertsBadgeCountLazyQuery,
    {
      fetchPolicy: 'cache-first',
      pollInterval: OPEN_ALERTS_POLL_INTERVAL,
    },
  )

  useEffect(() => {
    if (region && userCanSeeAlerts) {
      void fetchOpenAlerts({
        variables: {
          regionId: region.id,
        },
      })
    }
  }, [fetchOpenAlerts, region, userCanSeeAlerts])

  return {
    openPrebookingAlerts: queryResult?.openPrebookingAlerts.total ?? 0,
  }
}
